export default __webpack_public_path__ + "static/welder-light-24c1d23e85d2ce348c498382cb0f6fe9.jpg";